import {createContext} from "react";

export type AuthContextType = {
    isAuthorized: boolean;
    authLoaded: boolean;
    logout: () => void;
};

export const AuthContext = createContext<AuthContextType>({
    isAuthorized: false,
    authLoaded: false,
    logout: () => {
    },
});